import Link from 'next/link';
import styled from 'styled-components';

export const MoreMenu = styled.ul`
  height: calc(100% - 71px);
  width: 100%;
  position: fixed;
  flex-direction: column;
  list-style: none;
  padding: 0;
  top: 0;
  left: 0;
  background: ${(props) => props.theme.white};
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
`;

export const CustomMenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
  // font: inherit;
`;

export const LinkBox = styled(Link)`
  padding: 16px;
  cursor: pointer;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 63px;
  border-bottom: 1px solid ${(props) => props.theme.lightGrey};

  &:hover p {
    color: ${(props) => props.theme.primary};
  }
`;

export const OptionBox = styled.div`
  padding: 16px;
  cursor: pointer;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 63px;
  border-bottom: 1px solid ${(props) => props.theme.lightGrey};

  &:hover p {
    color: ${(props) => props.theme.primary};
  }
`;

export const SubmenuOptions = styled.ul<{ $show: boolean }>`
  display: flex;
  flex-direction: column;
  list-style: none;
  overflow: hidden;
  padding: 0;
  max-height: ${(props) => (props.$show ? '500px' : 0)};
  transition: max-height 0.5s ease-out;
`;

export const SubLinkBox = styled(Link)`
  padding: 20px;
  cursor: pointer;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 49px;

  &:hover p {
    color: ${(props) => props.theme.primary};
  }

  &:first-child {
    padding-top: 40px;
  }

  &:last-child {
    padding-bottom: 40px;
  }
`;

export const MenuIcon = styled.div`
  transition: all 1s;
`;
